/** The P1 hand-off (screens §P1, AC 2): after the welcome, an open unsubmitted pre attempt leads to A1, anything else to the reveal. */
import type { ApiClient } from "../api/client";

export type CheckContext = "async" | "in_room";

/** The facilitator's "call to the pre-check" link carries `?context=in_room`; every other way in is the invite. */
export const contextFromSearch = (search: string): CheckContext => (new URLSearchParams(search).get("context") === "in_room" ? "in_room" : "async");

export const preCheckPath = (cohortId: string, context: CheckContext): string => `/c/${cohortId}/check-in/pre${context === "in_room" ? "?context=in_room" : ""}`;
export const revealPath = (cohortId: string): string => `/c/${cohortId}/bank?step=reveal`;

/** Where the welcome leads, and the server's own sentence when the pre-check is put off ("the pre-check waits until the round ends; you can start playing"). */
export interface Handoff { readonly href: string; readonly notice: string | null }

export async function nextAfterWelcome(api: ApiClient, cohortId: string, search: string): Promise<Handoff> {
  const context = contextFromSearch(search);
  const started = await api.call("assessmentStart", { cohortId, phase: "pre" }, { context });
  if (started.ok && started.value.submittedAt === null) return { href: preCheckPath(cohortId, context), notice: null };
  // Not open (409) or unreachable: the check stays reachable from the invite, so the welcome never blocks the reveal; when the api says why, the person reads it.
  const said = !started.ok && started.error.code === "ASSESSMENT_NOT_OPEN" ? started.error.message.trim() : "";
  return { href: revealPath(cohortId), notice: said === "" ? null : said };
}
